var _a;
import { InteractionInteractedWith } from 'generated/types';
import { enumValuesFactory } from 'utils/objectHelper';
var enumDescriptionMap = (_a = {},
    _a[InteractionInteractedWith.Carrier] = 'Carrier',
    _a[InteractionInteractedWith.Client] = 'Client',
    _a[InteractionInteractedWith.Internal] = 'Internal',
    _a[InteractionInteractedWith.Manufacturer] = 'Manufacturer',
    _a[InteractionInteractedWith.Member] = 'Member',
    _a[InteractionInteractedWith.Other] = 'Other',
    _a[InteractionInteractedWith.Pharmacy] = 'Pharmacy',
    _a[InteractionInteractedWith.Provider] = 'Provider',
    _a[InteractionInteractedWith.TpaOrPartner] = 'TPA or partner',
    _a);
export var InteractionInteractedWithEnum = {
    name: 'InteractionInteractedWith',
    enumValues: enumValuesFactory(enumDescriptionMap)
};
